import React from 'react';
import { TextInput, View, Text, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';

import Colors from '../../constants/Colors'
import {stringIsEmpty} from "../../constants/StringChecker";

const Input  = (props) => {

    return (
        <View style={[styles.containerStyle, props.containerStyle]}>

            <View style={[styles.pointStyle, props.pointStyle]} />

            {
                stringIsEmpty(props.label) === false &&
                    <Text style={[styles.labelStyle, props.labelStyle]}>
                        {props.label}
                    </Text>
            }

            <TextInput
                style={[styles.inputStyle, props.inputStyle]}
                value={props.value}
                onChangeText={props.onChangeText}
                {...props}
            />

        </View>
    )
};

const styles = StyleSheet.create({
    containerStyle: {
        height: 50,
        flexDirection: 'row',
        alignItems: 'center',

        borderColor: Colors.inputLineColor,
        borderWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
    },
    pointStyle: {
        marginLeft: 8,
        marginRight: 8,
        width: 15,
        height: 15,
        borderRadius: 45,
        backgroundColor: Colors.inputBulletPoint,
    },
    labelStyle: {
        color: Colors.inputLineColor,
        fontSize: 14,
    },
    inputStyle: {
        flex: 1,
        fontSize: 14,
        color: Colors.inputFontColor,
    },
});

Input.propTypes = {
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    onChangeText: PropTypes.func.isRequired,

    label: PropTypes.string,
    showPoint: PropTypes.bool,

    containerStyle: PropTypes.object,
    pointStyle: PropTypes.object,
    labelStyle: PropTypes.object,
    inputStyle: PropTypes.object,
};

export { Input };

